import MDB from '@core/marketingdb';

/**
 * Append the given filter collection to the URL as part of the querystring
 *
 * @param {String} url
 * @param {Object[]} filters
 * @param {String} [filters.filterId]
 * @param {String} [filters.attributeId]
 * @param {String[]|String} filters.values
 *
 * @param {Boolean} [filters.inverted]
 * @param {Boolean} [filters.priority]
 *
 * @return {String}
 */
const appendFiltersToUrl = (url, filters) => MDB.Charts.appendFiltersToUrl(url, filters);

export {
  appendFiltersToUrl
};